/**
 * Returns an object with Chinese function words.
 *
 * @returns {Array} The array of Chinese function words.
 */

// Articles and determiners
const articles = ['这', '那', '这个', '那个', '这些', '那些', '一个', '一些'];

// Pronouns
const pronouns = [
  // Personal pronouns
  '我',
  '你',
  '他',
  '她',
  '它',
  '我们',
  '你们',
  '他们',
  '她们',
  '它们',
  // Possessive pronouns
  '我的',
  '你的',
  '他的',
  '她的',
  '它的',
  '我们的',
  '你们的',
  '他们的',
  '她们的',
  '它们的',
  // Demonstrative pronouns
  '这',
  '那',
  '这个',
  '那个',
  '这些',
  '那些',
  '这里',
  '那里',
  '这儿',
  '那儿'
];

// Prepositions
const prepositions = [
  '在',
  '从',
  '到',
  '向',
  '朝',
  '往',
  '由',
  '被',
  '把',
  '对',
  '为',
  '给',
  '跟',
  '和',
  '与',
  '同',
  '关于',
  '按照',
  '根据'
];

// Conjunctions
const conjunctions = [
  '和',
  '或',
  '但',
  '但是',
  '可是',
  '然而',
  '不过',
  '而且',
  '并且',
  '以及',
  '还有',
  '或者',
  '要么',
  '因为',
  '所以',
  '如果',
  '要是',
  '虽然',
  '尽管'
];

// Auxiliary verbs and modal verbs
const auxiliaries = [
  '是',
  '有',
  '没',
  '没有',
  '能',
  '可以',
  '会',
  '要',
  '想',
  '应该',
  '必须',
  '可能',
  '或许',
  '也许',
  '将',
  '将要',
  '正在',
  '已经',
  '刚刚'
];

// Quantifiers and numbers
const quantifiers = [
  '一',
  '二',
  '三',
  '四',
  '五',
  '六',
  '七',
  '八',
  '九',
  '十',
  '百',
  '千',
  '万',
  '亿',
  '个',
  '只',
  '条',
  '本',
  '张',
  '件',
  '台',
  '辆',
  '所',
  '座',
  '栋',
  '间',
  '层',
  '些',
  '点',
  '种',
  '样',
  '次',
  '遍',
  '回'
];

// Adverbs
const adverbs = [
  '很',
  '非常',
  '特别',
  '十分',
  '极',
  '太',
  '更',
  '最',
  '还',
  '也',
  '都',
  '只',
  '就',
  '才',
  '又',
  '再',
  '还是',
  '总是',
  '经常',
  '有时',
  '偶尔',
  '从来',
  '永远'
];

// Particles
const particles = [
  '的',
  '地',
  '得',
  '了',
  '着',
  '过',
  '呢',
  '吗',
  '吧',
  '啊',
  '呀',
  '哦',
  '嗯',
  '哪',
  '什么',
  '怎么',
  '为什么',
  '哪里',
  '哪儿',
  '怎样'
];

// Interjections
const interjections = [
  '哦',
  '啊',
  '呀',
  '哇',
  '嗯',
  '嘿',
  '喂',
  '哎',
  '唉',
  '咦',
  '哟',
  '呵',
  '嘻',
  '哈'
];

export const all = [].concat(
  articles,
  pronouns,
  prepositions,
  conjunctions,
  auxiliaries,
  quantifiers,
  adverbs,
  particles,
  interjections
);
